



























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('cases');

/* ----------------------------------------
    Sections
---------------------------------------- */

import Anchors from '@layout/Anchors.vue';
import Blocks from '@part/Blocks.vue';
import Contact from '@part/cases/Contact.vue';
import Download from '@part/cases/Download.vue';
import Header from '@layout/header/CaseHeader.vue';
import Next from '@part/cases/Next.vue';

/* ----------------------------------------
    JS Module
---------------------------------------- */

import { StickyAnchors } from '@js/module/StickyAnchors';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        Anchors,
        Blocks,
        Contact,
        Download,
        Header,
        Next
    },

    computed: {
        project() {
            const id = this.$route.params.id;
            return module.getters('getCaseById', id);
        },

        prevProject() {
            const id = this.$route.params.id;
            return module.getters('getPrevProject', id);
        },

        nextProject() {
            const id = this.$route.params.id;
            return module.getters('getNextProject', id);
        }
    },

    methods: {
        nextProjectImages: function(id) {
            const selected = module.getters('getNextId', id || this.$route.params.id);
            return module.getters('getCaseImages', selected);
        }
    },

    transition: {
        enter: (data, transition) => {
            const { el, parent } = data;
            const image = el.firstChild.querySelector('.case__image');

            transition.moveUp(el.firstChild, 650, 450);
            transition.fadeIn(image, 550, 450);
            transition.fadeIn(data.el, 550);
        },

        update: (data, transition) => {
            const { el, parent } = data;
            const image = el.firstChild.querySelector('.case__image');

            transition.fadeOut(image, 250);
            transition.fadeOut(data.el, 450, 750);

            setTimeout(() => {
                transition.moveUp(el.firstChild, 650, 250);
                transition.fadeIn(image, 550, 250);
                transition.fadeIn(data.el, 350);
            }, 1750)
        },

        leave: () => {

        }
    },

    beforeUpdate() {
        const images = this.nextProjectImages(this.project.id);
        this.loadImages(images);
    },

    updated() {
        const component = this.$el;
        const next = component.querySelector('.next');
        next.style.transform = 'translateY(100%)';
    },

    created() {
        const images = this.nextProjectImages();
        this.loadImages(images);
    },

    mounted() {
        new StickyAnchors();
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Case extends Vue {}

